// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__kErd5","navColor":"NavBar_navColor__dCvsE"};